import AuthService from '../../state/auth.service';
import axios from 'axios';

import endpoints from '../endpoints';

// const PENDING_STATUS_ID = 1;
// const ACCEPTED_STATUS_ID = 2;

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    accept(id) {
        // console.log("indicating a user has accepted invitation", id);
        return axios
            .put(
                endpoints.USER_BASE + `/${id}/accept`,
                {},
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            });
    },

    delete(id, orgId) {
        return axios
            .delete(endpoints.USER_BASE + `/${id}/${orgId}`, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    deleteConsultant(id) {
        return axios
            .delete(endpoints.USER_BASE + `/${id}/consultant`, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    create(props) {
        // console.log("creating a user with data", props);
        return axios
            .post(endpoints.USER_BASE, props, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },

    getLoggedInUser() {
        return axios
            .get(endpoints.USER_BASE, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            });
    },
    get(id) {
        // console.log("getting user with id", id);
        return axios
            .get(endpoints.USER_BASE + '/' + id, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    // This only gets the current user, not a specific user.
    getWithEmail(email) {
        // console.log("getting user with email", email);
        return axios
            .get(endpoints.USER_BASE, {
                params: { email: email },
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    getConsultantByEmail(email) {
        return axios
            .post(
                endpoints.USER_BASE + '/byemail',
                {
                    email: email,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Email Not Found : ${email}`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    invite(email, name, resource, role, orgId) {
        console.log('Invite Method', orgId);
        return axios
            .post(
                endpoints.USER_INVITE,
                {
                    email: email,
                    name: name,
                    resource: resource,
                    role: role,
                    orgId: orgId,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Server Error inviting user ${email}`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    list() {
        // console.log("getting all users");
        return axios
            .get(endpoints.USER_BASE + 's', {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Server error listing users...`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    listRoles() {
        return axios
            .get(endpoints.ROLES, {
                headers: getHeaders(),
            })
            .then(response => {
                if (response.data) {
                    return response.data;
                } else {
                    return false;
                }
            });
    },

    update(name, phone) {
        return axios
            .put(
                endpoints.USER_BASE,
                {
                    refreshToken: AuthService.getRefreshToken(),
                    idToken: AuthService.getIdToken(),
                    updates: {
                        name: name,
                        phone_number: phone,
                    },
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                throw err.message;
            });
    },

    updateAttrs(userJson) {
        let updates = Object.assign({}, userJson);

        return axios
            .put(
                endpoints.USER_BASE,
                {
                    refreshToken: AuthService.getRefreshToken(),
                    idToken: AuthService.getIdToken(),
                    updates: updates,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                throw err.message;
            });
    },

    getOrgTool(orgId) {
        console.log(getHeaders());
        return axios
            .post(
                endpoints.ORG_TOOL,
                {
                    organization_id: orgId,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Server Error retrieving tool for organiation ${orgId}`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },

    getPracticeTool(practiceId) {
        return axios
            .post(
                endpoints.PRACTICE_TOOL,
                {
                    practice_id: practiceId,
                },
                {
                    headers: getHeaders(),
                }
            )
            .then(response => {
                return response.data;
            })
            .catch(err => {
                let message = `Server Error retrieving tool for practice ${practiceId}`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },
    /*{
    path: '/user/getOrgTool',
    method: 'POST',
    handler: Utils.getOrgTool,
    config: RouteUtils.authenticatedConfig()
}, {
    path: '/user/getPracticeTool',
    method: 'POST',
    handler: Utils.getPracticeTool,
    config: RouteUtils.authenticatedConfig()
}*/
};
